'use strict';

const VERSION = '1.0.0';
const NAME = 'scripts-search';

let config = {
    minSearchQueryLength: 3, // search with this length
};

let searchInputFromMenu;
let searchBox;
let searchInputFromSearchBox;
let searchBoxResults;
let clearResultsButton;

function init(options) {
    console.log(NAME, 'init');

    Object.assign(config, options);

    searchInputFromMenu = document.querySelector(`#searchInputFromMenu`);
    if (searchInputFromMenu) {
        searchInputFromMenu.addEventListener('keyup', change);
    }

    searchBox = document.querySelector(`.searchBox`);
    if (!searchBox) {
        return;
    }
    searchInputFromSearchBox = searchBox.querySelector(`input[name="search"]`);
    if (searchInputFromSearchBox) {
        searchInputFromSearchBox.addEventListener('keyup', change);
    }
    searchBoxResults = searchBox.querySelector(`.results`);

    clearResultsButton = searchBox.querySelector(`button`);
    if (clearResultsButton) {
        clearResultsButton.addEventListener('click', ev => {
            hideSearch();
        });
    }

    document.querySelectorAll(`.button.is-search, .navbar-item.is-search`).forEach(element => {
        element.addEventListener('click', showSearchBox);
    });
}

function change(e) {
    try {
        let keyCode = e.keyCode || e.which;
        if (keyCode === 27) {
            hideSearch();
        }
    } catch (exception) {
    }

    // console.log(e.currentTarget, searchInputFromMenu, e.currentTarget === searchInputFromMenu);

    if (e.currentTarget === searchInputFromMenu) {
        let value = stringToSearchWords(searchInputFromMenu.value);
        if (value.length < config.minSearchQueryLength) {
            return;
        }
        hideNavBars();
        showSearchBox();
        searchInputFromSearchBox.value = searchInputFromMenu.value;
    }

    let value = stringToSearchWords(searchInputFromSearchBox.value);
    if (value.length < config.minSearchQueryLength) {
        return;
    }
    // console.log('search', value);
    search(value);
}

function hideSearch() {
    hideNavBars();
    hideSearchBox();
}

function showSearchBox() {
    searchBox.classList.remove('is-hidden');
    searchInputFromSearchBox.focus();
}
function hideSearchBox() {
    searchBox.classList.add('is-hidden');
    searchInputFromSearchBox.blur();
}
function toggleSearchBox() {
    searchBox.classList.toggle('is-hidden');
    if (searchBox.classList.contains('is-hidden')) {
        searchInputFromSearchBox.blur();
    } else {
        searchInputFromSearchBox.focus();
    }
}

let isSearching = false;
let shouldResumeSearch = true;
let searchQuery;

function populateResults(products) {
    console.log(NAME, 'populateResults');
    // console.log(NAME, 'populateResults', products);
    searchBoxResults.innerHTML = products;
    LazyLoad.init();

//     if (!products || products.length === 0) {
//         return;
//     }
//
//     products.forEach(product => {
//
//         searchBoxResults.innerHTML += `
// <div class="product is-product-link" data-product-url="/buchet-lalele-multicolore-plenitudinea-culorii/" data-product-id="gLSLGFA7bp"><div class="image cover-contain is-lazy-background" data-src="https://res.cloudinary.com/wisebeam/image/upload/c_fit,h_600,q_80,w_600/v1/upload/buchet-99-lalele-multicolore-plenitudinea-culorii_yyg2jx.jpg" style="background-image: url(&quot;https://res.cloudinary.com/wisebeam/image/upload/c_fit,h_600,q_80,w_600/v1/upload/buchet-99-lalele-multicolore-plenitudinea-culorii_yyg2jx.jpg&quot;);"></div><div class="details"><a class="is-block" href="/buchet-lalele-multicolore-plenitudinea-culorii/" title="Buchet lalele multicolore (Plenitudinea Culorii)"><div class="subtitle">Buchet lalele multicolore</div><div class="title">Plenitudinea Culorii</div></a><div class="subtitle"></div><div class="pricing"><div class="price" data-product-id="gLSLGFA7bp" data-product-url="/buchet-lalele-multicolore-plenitudinea-culorii/">450 RON</div></div></div></div>
//         `;
//     });
}

function search(query) {
    if (query === searchQuery) {
        return;
    } else {
        searchQuery = query;
    }
    if (isSearching) {
        shouldResumeSearch = true;
        return;
    }
    isSearching = true;
    searchInputFromSearchBox.parentNode.classList.add('is-loading');
    fetchResults(searchQuery)
        .then(products => {
            populateResults(products);
            resumeSearchIfNeeded();
        })
        .catch(error => {
            console.error(error);
            resumeSearchIfNeeded();
        });
}

function resumeSearchIfNeeded() {
    isSearching = false;
    searchInputFromSearchBox.parentNode.classList.remove('is-loading');
    if (shouldResumeSearch) {
        shouldResumeSearch = false;
        search(searchQuery);
    }
}

function fetchResults(query) {
    return new Promise((resolve, reject) => {
        let data = JSON.stringify({searchQuery: query});

        let xhr = new XMLHttpRequest();
        xhr.withCredentials = true;

        xhr.addEventListener("readystatechange", function() {
            if(this.readyState === 4) {
                if (this.status === 200) {
                    // console.log(this.responseText);
                    resolve(this.responseText);
                } else {
                    reject(new Error(this.statusText));
                }
            }
        });
        xhr.addEventListener("error", ev => {
            reject(new Error("No connection"));
        });

        xhr.open("POST", language === 'ro' ? `/cauta/` : `/${language}/search/`);
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.send(data);
    });
}

function stringToSearchWords(str) {
    str = str.replace(/[\'\:\/\[\]-]/g,'');
    str = str.replace(/[\s\'\:\/\[\]-]+/g,' ');

    return str;
}

module.exports = {
    VERSION: VERSION,
    NAME: NAME,

    init: init,
};